content-text-block {
  display: block;
  width: 100%;
  // height: 100%; // for content-block-tout mediaContent button positioning
  text-align: initial;
  // content-hero-block &,
  // content-grid-formatter & {
  //   height: auto;
  //   &[vertical="bottom"],
  //   &[vertical="center"] {
  //     height: 100%;
  //   }
  // }
  
  &[full-height="true"] {
    height: 100%;
  }
  > *[slot="footer"] {
    margin-top: auto;
    margin-bottom: 0;
    width: 100%;
    padding-top: 1rem;
    height: auto;
    // @media #{$tablet-landscape-up} {
    //   margin-top: auto;
    //   margin-bottom: 0;
    //   width: 100%;
    // }
  }
  &[vertical="bottom"] > [slot="footer"] {
    position: static;
    height: auto;
  }
  &[vertical] {
    display: flex;
    flex-direction: column;
  }

  &[vertical="top"] {
    justify-content: flex-start;
  }
  &[vertical="center"] {
    justify-content: center;
    &[footer="true"] {
      .content-text-block__content {
        margin-top: auto;
        margin-bottom: 0;
      }
    }
  }
  &[vertical="bottom"] {
    justify-content: flex-end;
    &[footer="true"] {
      .content-text-block__content {
        margin-top: auto;
        margin-bottom: 0;
      }
      > [slot="footer"] {
        margin-top: 0;
      }
    }
  }

  &[text-align="left"] {
    text-align: left;
  }
  &[text-align="center"] {
    text-align: center;
  }
  &[text-align="right"] {
    text-align: right;
  }
}